import { useMemo, useEffect } from 'react';
import { brandsSelector } from '../redux/selectors/brandsSelector';
import { useAppSelector } from '../redux/store';

const useBrands = () => {
  const {
    brands,
    filterValue,
    status: brandsStatus,
  } = useAppSelector(brandsSelector);

  const availableBrands = useMemo(() => {
    return brands.filter(
      (item) =>
        !(String(item.status) === '0') &&
        !(String(item.menu_visibility) === '0'),
    );
  }, [brands]);

  const filteredBrands = useMemo(() => {
    if (filterValue) {
      return availableBrands.filter((brand) =>
        brand.manufacturer_name
          .toLowerCase()
          .includes(filterValue.toLowerCase()),
      );
    }
    return availableBrands;
  }, [availableBrands, filterValue]);

  useEffect(() => {
    const searchItemsChange = new CustomEvent('searchItemsChange', {
      detail: {
        brands,
      },
    });
    document.dispatchEvent(searchItemsChange);
  }, [brands]);

  return { filteredBrands, brands: availableBrands, filterValue, brandsStatus };
};

export default useBrands;
